import React from 'react'
import { format } from 'd3-format'
import createMeasurement from './Measurements'
import R from 'ramda'
import styled from 'styled-components'

const Guide = styled.line`
  stroke: #999;
`
const YGuideText = styled.text`
  text-anchor: middle;
  fill: #444;
  font-weight: bold;
  alignment-baseline: hanging;
`
const XGuideText = styled.text`
  text-anchor: end;
  fill: #444;
  font-weight: bold;
  alignment-baseline: baseline;
`

const ScatterGuides = ({
  measurement = createMeasurement({}),
  dot,
  xFormat = format('.3s'),
  yFormat = format('.3s'),
  xGetter,
  yGetter,
}) => {
  if (R.isNil(dot)) return null
  const { margin } = measurement

  return (
    <g transform={`translate(${margin.left},${margin.top})`}>
      <Guide x1={0} y1={dot.cy} x2={dot.cx} y2={dot.cy} />
      <Guide x1={dot.cx} y1={measurement.innerHeight} x2={dot.cx} y2={dot.cy} />
      <YGuideText x={dot.cx} y={measurement.innerHeight + 18}>
        {xFormat(xGetter(dot.data))}
      </YGuideText>
      <XGuideText x={-15} y={dot.cy}>
        {yFormat(yGetter(dot.data))}
      </XGuideText>
    </g>
  )
}
export default ScatterGuides
